/**
 * Converts all the alphabetic characters in a string to uppercase
 * @param value value to be converted
 * @returns value as uppercase
 */
export function hbsHelperU(value: string): string {
  return value.toUpperCase();
}